import { REMINDER_TYPES, type TReminder } from '@src/shared/types/reminder';
import { RULE_TYPES, type TRule } from '@src/shared/types/rule';

import { createStageReminderInitialValues } from '../components/create-reminder/schema';

/** The reminder type whose Rule field lists this rule kind; every other kind is an "Other Rules" rule. */
const REMINDER_TYPE_BY_RULE_TYPE: Partial<
  Record<TRule['type'], TReminder['type']>
> = {
  [RULE_TYPES.date]: REMINDER_TYPES.dateRule,
  [RULE_TYPES.flightInfo]: REMINDER_TYPES.flightInfo,
};

/** Stage reminder values pre-filled with the rule the reminder was added from. */
export function createStageReminderInitialValuesFromRule(
  rule: Pick<TRule, 'id' | 'type' | 'flight_type'>
) {
  const isFlightInfoRule = rule.type === RULE_TYPES.flightInfo;

  return {
    ...createStageReminderInitialValues(),
    type: REMINDER_TYPE_BY_RULE_TYPE[rule.type] ?? REMINDER_TYPES.otherRules,
    rule: String(rule.id),
    rule_type: rule.type,
    ...(isFlightInfoRule &&
      rule.flight_type && { flight_type: rule.flight_type }),
  };
}
